import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Ticket } from '../models/ticket';

export interface TicketRequest {
  account: string | null;
  ticket: string | null;
  amount: number | null;
}

@Injectable({
  providedIn: 'root',
})
export class TicketService {
  private apiUrl = environment.backClient;

  constructor(private http: HttpClient) {}

  createTicket(ticketData: TicketRequest): Observable<any> {
    return this.http.post(`${this.apiUrl}/createTicket`, ticketData);
  }
  getAllTickets(): Observable<{ tickets: Ticket[] }> {
    return this.http.get<{ tickets: Ticket[] }>(`${this.apiUrl}/tickets/`);
  }
  getCategories(): Observable<any> {
    return this.http.get(`${this.apiUrl}/merchant/categories`);
  }
  getTicketAmount(): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get<any>(`${this.apiUrl}/company/ticketAmount`, {
      headers,
    });
  }

  updateTicketAmount(amount: number): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.put<any>(
      `${this.apiUrl}/company/setTicketAmount`,
      { amount: amount },
      {
        headers,
      }
    );
  }
}
